export default {
    dependencies: ['objectstore'],
    callable(objectstore) {
        const url = new URL(document.baseURI);
        const finnkode = url.searchParams.get('finnkode');
        if (!finnkode) {
            return;
        }

        prependToStorage('visited_ads', 3, finnkode);

        function prependToStorage(key, maxNumberOfEntries, id) {
            const ONE_WEEK_SECONDS = 60 * 60 * 24 * 7;
            let value = objectstore.get(key);

            if (value) {
                if (Array.isArray(value) && value.indexOf(id) === -1) {
                    value.unshift(id);
                    value = value.slice(0, maxNumberOfEntries);
                } else {
                    value = [id];
                }
                objectstore.put(key, value, ONE_WEEK_SECONDS);
            } else {
                objectstore.put(key, [id], ONE_WEEK_SECONDS);
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/storeVisitedAd.js